import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { TrustpilotUtils } from "../../shared/utilities/trustpilotUtils";
import { IProductReviewsAggregate } from "./reviewsAggregate";

export interface IReviewWidgetAggregateComponent extends IInstanceComponentBase {
    reviewsAverage: number;
    totalReviews: number;
    update: (reviewsAverage: number, totalReviews: number) => void;
}
export class ReviewWidgetAggregateComponent extends InstanceComponentBase implements IReviewWidgetAggregateComponent {
    public reviewsAverage: number;
    public totalReviews: number;

    constructor(public htmlElement: HTMLElement) {
        super(htmlElement);

        this.setReviewsAverage();
        this.setTotalReviews();
    }

    setReviewsAverage(): void {
        this.reviewsAverage = +HelperUtils.getValueForElementAndAttributeOrThrows(this.htmlElement, AttributeEnums.ReviewWidgetAggregateComponent.reviewsAverage);
    }

    writeToReviewsAverage(reviewsAverage: number): void {
        HelperUtils.setValueForElementAndAttributeOrThrows(reviewsAverage.toString(), this.htmlElement, AttributeEnums.ReviewWidgetAggregateComponent.reviewsAverage);
    }

    updateReviewsAverage(reviewsAverage: number): void {
        this.writeToReviewsAverage(reviewsAverage);
        this.setReviewsAverage();
    }

    setTotalReviews(): void {
        this.totalReviews = +HelperUtils.getValueForElementAndAttributeOrThrows(this.htmlElement, AttributeEnums.ReviewWidgetAggregateComponent.totalReviews);
    }

    writeToTotalReviews(totalReviews: number): void {
        HelperUtils.setValueForElementAndAttributeOrThrows(totalReviews.toString(), this.htmlElement, AttributeEnums.ReviewWidgetAggregateComponent.totalReviews);
    }

    updateTotalReviews(totalReviews: number): void {
        this.writeToTotalReviews(totalReviews);
        this.setTotalReviews();
    }

    setDisplayTotalReviews():void{
        let totalReviewsElement: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewWidgetAggregateComponent.totalReviews))
        totalReviewsElement.innerHTML = `(${this.totalReviews} Reviews)`;
    }

    setDisplayReviewsAverage():void{
        let reviewsAverageElement: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewWidgetAggregateComponent.reviewsAverage))
        reviewsAverageElement.innerHTML = `${this.reviewsAverage}/5`;
    }

    setDisplayStarImage():void{
        let starImageElement: HTMLImageElement = this.htmlElement.querySelector('img')
        starImageElement.src = TrustpilotUtils.GetReviewStarSvgPath(this.reviewsAverage);
    }

    updateDisplay():void{
      this.setDisplayTotalReviews();
      this.setDisplayReviewsAverage();
      this.setDisplayStarImage();
    }

    update(reviewsAverage: number, totalReviews: number): void  {
        this.updateReviewsAverage(reviewsAverage);
        this.updateTotalReviews(totalReviews);
        this.updateDisplay();
    }

    dispose()
    {

    }

}